'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$4() {
  this.bhZ = null;
  this.bhX = null;
  this.bhY = false;
  this.bhV = null;
  this.bhW = false;
  this.bi0 = false;
  this.bi1 = false;
  this.bhZ = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_PrestoRouter$$anon$4 as $c_Lpresto_PrestoRouter$$anon$4 };
$p = $c_Lpresto_PrestoRouter$$anon$4.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$4;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$4() {
}
export { $h_Lpresto_PrestoRouter$$anon$4 as $h_Lpresto_PrestoRouter$$anon$4 };
$h_Lpresto_PrestoRouter$$anon$4.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.ad = (function() {
  return this.bhZ;
});
$p.t = (function() {
  if ((!this.bhY)) {
    this.bhX = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bhY = true;
  }
  return this.bhX;
});
$p.ae = (function() {
  if ((!this.bhW)) {
    this.bhV = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bhW = true;
  }
  return this.bhV;
});
$p.w = (function() {
  if ((!this.bi1)) {
    this.bi0 = false;
    this.bi1 = true;
  }
  return this.bi0;
});
$p.ac = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lpresto_PrestoRouter$$anon$4 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$4, "presto.PrestoRouter$$anon$4", ({
  O5: 1,
  a: 1,
  k: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$4 as $d_Lpresto_PrestoRouter$$anon$4 };
//# sourceMappingURL=presto.-Presto-Router$$anon$4.js.map
